import { CONTRACT_TYPE_CLIENT, ContractDto, ContractStatus, ContractType, UpdateContractDto, DownloadFileDto } from '@sr/dto';
import { FormTools, VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';
import { isBefore } from 'date-fns';
import { FormikErrors } from 'formik';
import { validateDateField } from 'utils/date-validation';

export type FormData = {
  contractTemplateId?: number | '';
  name: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  unlimited: boolean;
  autoprolong: boolean;
  status: ContractStatus | '';
  managerId: number | '';
  attachmentFile: DownloadFileDto[] | null,
  type?: ContractType;
  specialConditions: string | undefined;
};

export const formTools: FormTools<ContractDto, void, UpdateContractDto, FormData> = {
  toCreateDto: (formData) => null,

  toUpdateDto: (id, formData): UpdateContractDto => ({
    id: id,
    contractTemplateId: Number(formData.contractTemplateId),
    status: formData.status as ContractStatus,
    name: formData.name,
    type: Number(formData.type) as ContractType,
    specialConditions: formData.specialConditions,
    contractStartDate: formData.startDate ? new Date(formData.startDate) : new Date(),
    contractEndDate: formData.unlimited || !formData.endDate ? undefined : new Date(formData.endDate),
    autoprolong: formData.autoprolong,
    managerId: formData.managerId ? Number(formData.managerId) : undefined,
    attachmentFileId: formData.attachmentFile?.length ? formData.attachmentFile[0].id :  null,
    attachmentFiles: formData.attachmentFile ?? []
  }),

  fromDto: (dto): FormData => ({
    status: dto.status,
    contractTemplateId: dto.template?.id || undefined,
    name: dto.name,
    specialConditions: dto.specialConditions,
    startDate: dto.contractStartDate,
    endDate: dto.contractEndDate,
    unlimited: !dto.contractEndDate,
    autoprolong: dto.autoprolong,
    managerId: dto.manager ? dto.manager.id : '',
    attachmentFile: dto.attachmentFiles ?? (dto.attachmentFile ? [dto.attachmentFile] : null),
    type: Number(dto.type) as ContractType
  }),

  validate: (values: FormData): FormikErrors<FormData> => {
    let validationResult: FormikErrors<FormData> = {};

    if (values.type === CONTRACT_TYPE_CLIENT && !values.managerId) validationResult.managerId = VALIDATION_REQUIRED_FIELD;

    if (!values.startDate) validationResult.startDate = VALIDATION_REQUIRED_FIELD;
    else validateDateField('startDate', values, validationResult);

    if (!values.unlimited) {
      if (values.endDate === undefined) validationResult.endDate = VALIDATION_REQUIRED_FIELD;
      else validateDateField('endDate', values, validationResult);
    }

    if (values.startDate && values.endDate)
      if (isBefore(values.endDate, values.startDate)) {
        validationResult.startDate = 'Дата начала не может быть больше конца';
        validationResult.endDate = 'Дата начала не может быть больше конца';
      }

    return validationResult;
  },
  emptyValues: () => ({
    contractTemplateId: '',
    attachmentFile: null,
    name: '',
    startDate: undefined,
    endDate: undefined,
    unlimited: false,
    autoprolong: false,
    status: '',
    managerId: '',
    scanFile: null,
    type: undefined,
    specialConditions: ''
  })
};
